import { render, staticRenderFns } from "./editContact.vue?vue&type=template&id=4d20968c&scoped=true&"
import script from "./editContact.vue?vue&type=script&lang=js&"
export * from "./editContact.vue?vue&type=script&lang=js&"
import style0 from "./editContact.vue?vue&type=style&index=0&id=4d20968c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20968c",
  null
  
)

export default component.exports